module.exports = __webpack_public_path__ + "img/34.7e97f797.jpg";